<template>
  <div class="row recommend-container">
    <div class="recommend-list">
      <recommend-news-list></recommend-news-list>
    </div>
    <div class="week-fast-news">
      <WeekFastNewsList></WeekFastNewsList>
    </div>
  </div>
</template>

<script>
import RecommendNewsList from '@/components/recommend/RecommendNewsList';
import WeekFastNewsList from '@/components/recommend/WeekFastNewsList';

export default {
  data() {
    return {
      rightContent: null
    };
  },
  components: {
    RecommendNewsList,
    WeekFastNewsList
  }
};
</script>

<style lang="scss" scoped>
  .recommend-container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 16px;
    min-height: calc(100vh - 59px);
    .recommend-list {
      width: 764px;
      min-height: 600px;
      margin-right: 10px;
    }
    .week-fast-news {
      width: 426px;
      height: calc(100vh - 80px);
      background: #ffffff;
    }
  }
</style>

